import { render, staticRenderFns } from "./MobileWorkflowView.vue?vue&type=template&id=c56dd43c&scoped=true"
import script from "./MobileWorkflowView.vue?vue&type=script&lang=js"
export * from "./MobileWorkflowView.vue?vue&type=script&lang=js"
import style0 from "./MobileWorkflowView.vue?vue&type=style&index=0&id=c56dd43c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c56dd43c",
  null
  
)

export default component.exports